"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _intersectionObserver = _interopRequireDefault(require("intersection-observer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var hasIntersectionObserver = typeof window !== "undefined" && !!window.IntersectionObserver;
var IntersectionObserver = hasIntersectionObserver ? window.IntersectionObserver : _intersectionObserver.default;

function createObserver(handler, el, observerOptions) {
  var observer = new IntersectionObserver(handler, observerOptions);
  observer.observe(el);
  return observer;
}

var _default = createObserver;
exports.default = _default;